import { useEffect } from "react"

const useTimeoutEffect = (updateObject: any, action: Function, deps: any[], timeoutDuration: number) => {
    useEffect(() => {
        let timeoutId
        if (updateObject && Object.keys(updateObject)?.length > 0) {
            timeoutId = setTimeout(() => action(), timeoutDuration)
        }
        return () => clearTimeout(timeoutId)
    }, deps)
}

export default useTimeoutEffect;